export default class CookieBanner {
  constructor(el) {
    this.el = el;

    this.openButton = null;
    this.cookiePopup = null;
    this.closeButton = null;
    this.init();
    this.initEvents();
  }

  init() {
    this.openButton = this.el.querySelector("#set-cookies");
    this.cookiePopup = this.el.querySelector(".cookie-consent-popup-backdrop");
    this.closeButton = this.el.querySelector(".cookie-consent-popup__close");

    this.checkAllButton = this.el.querySelector(".cookie-consent-popup__link--check");
    this.uncheckAllButton = this.el.querySelector(".cookie-consent-popup__link--uncheck");

    this.cookieRowConfirm = this.el.querySelector("#cookies-confirm");
    this.analyticsCheckbox = this.el.querySelector("#sv-analytical-cookies");
    this.trackingCheckbox = this.el.querySelector("#sv-tracking-cookies");
    this.functionalBtn = this.el.querySelector("#sv-banner-functional-cookies");
    this.analyticsBtn = this.el.querySelector("#sv-banner-analytical-cookies");
    this.cookieConsentName = "sv-cookie-consent";

    var cookieValue = this.getCookie(this.cookieConsentName);

    this.showBanner(cookieValue);
    if (cookieValue === "sv-analytical-cookies") {
      this.analyticsCheckbox.checked = true;
    }

    if (cookieValue === "sv-tracking-cookies") {
      this.analyticsCheckbox.checked = true;
      this.trackingCheckbox.checked = true;
    }
  }

  initEvents() {
    this.openButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.showPopup();
    });
    this.closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.showPopup();
    });

    this.cookieRowConfirm.addEventListener("click", () =>
      this.handleCookieRowConfirmClick()
    );
    this.analyticsCheckbox.addEventListener("change", () =>
      this.handleAnalyticsChange()
    );
    this.trackingCheckbox.addEventListener("change", () =>
      this.handleTrackingChange()
    );

    this.functionalBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleFunctionalBtn();
    });

    this.analyticsBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleAnalyticsBtn();
    });

    this.checkAllButton.addEventListener("click", (e) => {
      this.analyticsCheckbox.checked = true;
      this.trackingCheckbox.checked = true;
    });

    this.uncheckAllButton.addEventListener("click", (e) => {
      this.analyticsCheckbox.checked = false;
      this.trackingCheckbox.checked = false;
    });
  }

  showPopup() {
    this.cookiePopup.classList.toggle("is-visible");
  }

  showBanner(cookies) {
    if(this.el){
      if (cookies === "") {
        this.el.querySelector(".cookie-consent-banner").style.display = "flex";
      } else {
        this.el.querySelector(".cookie-consent-banner").style.display = "none";
      }
    }    
  }
  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  handleCookieRowConfirmClick() {
    var cookie = "sv-functional-cookies";

    if (this.analyticsCheckbox.checked) {
      cookie = "sv-analytical-cookies";
    }

    if (this.trackingCheckbox.checked) {
      cookie = "sv-tracking-cookies";
    }

    document.cookie =
      this.cookieConsentName +
      "=" +
      cookie +
      "; expires=Thu, 18 Dec 2999 12:00:00 UTC; path=/";

    this.showPopup();
    this.showBanner(this.getCookie(this.cookieConsentName));
  }

  handleAnalyticsChange() {
    if (!this.analyticsCheckbox.checked) {
      this.trackingCheckbox.checked = false;
    }
  }

  handleTrackingChange() {
    if (this.trackingCheckbox.checked) {
      this.analyticsCheckbox.checked = true;
    }
  }

  handleFunctionalBtn() {
    var cookie = "sv-functional-cookies";

    document.cookie =
      this.cookieConsentName +
      "=" +
      cookie +
      "; expires=Thu, 18 Dec 2999 12:00:00 UTC; path=/";
    this.showBanner(this.getCookie(this.cookieConsentName));
    _mtm.push({"event": "cookiebanner_update"});
  }

  handleAnalyticsBtn() {
    var cookie = "sv-analytical-cookies";

    document.cookie =
      this.cookieConsentName +
      "=" +
      cookie +
      "; expires=Thu, 18 Dec 2999 12:00:00 UTC; path=/";
    this.showBanner(this.getCookie(this.cookieConsentName));
    _mtm.push({"event": "cookiebanner_update"});
  }
}
